module.exports = __webpack_public_path__ + "static/money-transfer-tab-app-cover-cf94b987a1269cb5220acae974ad0615.png";